let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5XMUp")).then(() => parcelRequire('16SCI'));